// extracted by mini-css-extract-plugin
export default {"wrapper":"FadeIn_wrapper__63jGp","init":"FadeIn_init__3yf8s"};